<template>
  <li class="slds-accordion__list-item">
    <section class="slds-accordion__section" :class="{'slds-is-open': show}">
      <div class="slds-accordion__summary">
        <h2 class="slds-accordion__summary-heading">
          <button :aria-controls="`accordion-details-${id}`" aria-expanded="true" class="slds-button slds-button_reset slds-accordion__summary-action" @click="toggleShow">
            <svg class="slds-accordion__summary-action-icon slds-button__icon slds-button__icon_left" aria-hidden="true">
              <use xlink:href="../../assets/symbols.svg#switch"></use>
            </svg>
            <span class="slds-accordion__summary-content" :class="{'has-error': hasError}" :title="title">{{title}}</span>

            <transition name="fade">
              <span class="slds-tabs__right-icon" v-if="hasError">
                <span class="slds-icon_container slds-icon-utility-error">
                  <svg class="slds-icon slds-icon_x-small slds-icon-text-error" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#error"></use>
                  </svg>
                </span>
              </span>
            </transition>
          </button>
        </h2>
        <slot name="actions"></slot>
      </div>
      <div class="slds-accordion__content" :id="`accordion-details-${id}`">
        <slot />
      </div>
    </section>
  </li>
</template>
<script>
import EventBus from '../utils/EventBus'
export default {
  props: {
    accordionItemId: String,
    defaultOpen: Boolean,
    title: String
  },
  created () {
    EventBus.$on('setAccordionError', params => {
      if (params.accordionItemId === this.accordionItemId) {
        this.hasError = params.isError
      }
    })
  },
  data () {
    return {
      hasError: false,
      id: parseInt(Math.random() * 1000),
      show: this.defaultOpen
    }
  },
  methods: {
    toggleShow () {
      this.show = !this.show
    }
  },
  watch: {
    hasError (newValue, oldValue) {
      if (!oldValue && newValue) {
        this.show = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .has-error {
    color: #C23933
  }
</style>
